import React from 'react';
import { Link } from 'react-router-dom'
import strings from "./../../../components/Language";

import './menu.scss';

import { IconLink, IconUserPlus, IconWallet, IconZap, IconGift } from '../../../components/Icons';

import { toast } from 'react-toastify';
import { getToken, storeUserData, getUserData } from './../../../components/Util';
import axios from 'axios';
import { api } from '../../../components/config/api';
class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            access_token: "",
            user_data: {},
            isStart: false
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            setTimeout(() => {
                this.setState({ access_token: token });
                var user_data = getUserData();
                if (user_data && user_data.data) {
                    this.setState({ user_data: user_data });
                }
                this.getData();
            });
        }
    }

    getData() {
        var self = this;
        if (self.state.access_token) {
            axios({
                method: 'GET',
                url: api.auto_trade,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                if (ress.data && ress.data.error === 200) {
                    self.setState({
                        isStart: ress.data.data.status,
                    });
                }
                self.setState({ is_load: false });
            }).catch(function (e) {
                self.setState({ is_load: false });
            });
        }
    };

    tile(content, label, extraClass) {
        return (
            <>
                <span className={"qa-icon" + (extraClass ? " " + extraClass : "")}>{content}</span>
                <span className="qa-label">{label}</span>
            </>
        );
    }

    render() {
        const isActiveUser = !!(this.state.user_data && this.state.user_data.status);
        const running = !!this.state.isStart;
        return (
            <nav className="quick-actions" aria-label="Quick actions">
                <Link to="/apibind" className="qa-item">
                    {this.tile(<IconLink />, strings.api_bind)}
                </Link>
                {isActiveUser ?
                    <Link to="/invite-link" className="qa-item">
                        {this.tile(<IconUserPlus />, strings.share)}
                    </Link>
                    :
                    <button type="button" className="qa-item" onClick={() => toast.warning(strings.need_to_active_account)}>
                        {this.tile(<IconUserPlus />, strings.share)}
                    </button>
                }
                <Link to="/wallet" className="qa-item">
                    {this.tile(<IconWallet />, strings.wallet)}
                </Link>
                <Link to="/auto-trade" className={"qa-item" + (running ? " is-running" : "")}>
                    {this.tile(
                        <>
                            <IconZap />
                            {running ? <span className="live_dot" title={strings.auto_trade_on || "Auto trade on"} /> : null}
                        </>,
                        strings.AutoTrade,
                        running ? "qa-icon-live" : ""
                    )}
                </Link>
                <Link to="/reward" className="qa-item">
                    {this.tile(<IconGift />, strings.rewards)}
                </Link>
            </nav>
        );
    };
}

export default Menu;
